import * as types from "./types";

export const getCompanyLogisticsIssuesRequest = (payload) => ({
  type: types.GET_COMPANY_LOGISTICS_ISSUES_REQUEST,
  payload,
});

export const getCompanyLogisticsIssuesResponse = (payload) => ({
  type: types.GET_COMPANY_LOGISTICS_ISSUES_RESPONSE,
  payload,
});

export const createCompanyLogisticsIssueRequest = (payload) => ({
  type: types.CREATE_COMPANY_LOGISTICS_ISSUE_REQUEST,
  payload,
});

export const createCompanyLogisticsIssueResponse = (payload) => ({
  type: types.CREATE_COMPANY_LOGISTICS_ISSUE_RESPONSE,
  payload,
});

export const getCompanyLogisticsIssueDetailRequest = (payload) => ({
  type: types.GET_COMPANY_LOGISTICS_ISSUE_DETAIL_REQUEST,
  payload,
});

export const getCompanyLogisticsIssueDetailResponse = (payload) => ({
  type: types.GET_COMPANY_LOGISTICS_ISSUE_DETAIL_RESPONSE,
  payload,
});

export const updateCompanyLogisticsIssueRequest = (payload) => ({
  type: types.UPDATE_COMPANY_LOGISTICS_ISSUE_REQUEST,
  payload,
});

export const updateCompanyLogisticsIssueResponse = (payload) => ({
  type: types.UPDATE_COMPANY_LOGISTICS_ISSUE_RESPONSE,
  payload,
});

export const getCompanyLogisticsIssueCommentsRequest = (payload) => ({
  type: types.GET_COMPANY_LOGISTICS_ISSUE_COMMENTS_REQUEST,
  payload,
});

export const getCompanyLogisticsIssueCommentsResponse = (payload) => ({
  type: types.GET_COMPANY_LOGISTICS_ISSUE_COMMENTS_RESPONSE,
  payload,
});

export const createCompanyLogisticsIssueCommentRequest = (payload) => ({
  type: types.CREATE_COMPANY_LOGISTICS_ISSUE_COMMENT_REQUEST,
  payload,
});

export const createCompanyLogisticsIssueCommentResponse = (payload) => ({
  type: types.CREATE_COMPANY_LOGISTICS_ISSUE_COMMENT_RESPONSE,
  payload,
});

export const exportCompanyLogisticsIssuesRequest = (payload) => ({
  type: types.EXPORT_COMPANY_LOGISTICS_ISSUES_REQUEST,
  payload,
});
